export enum PurchaseWebhookType {
    Disabled = 'Disabled',
    Barcode = 'Barcode',
}

export interface PurchaseWebhook {
    // Type of the webhook (what type of information does the webhook obtain, ie. 'Barcode')
    webhookType?: PurchaseWebhookType,
    // Internal or external webhook to obtain/allocate purchased barcode/ticket etc.
    webhookUrl?: string,
    // Id of the product named by the partner barcode (ie. TivoliEntrance)
    partnerProductId?: string,
}
